import { handleActions } from 'redux-actions';

import SEARCH_QUERY_FIELDS from 'shared/constants/search-query-fields';
import { NAMES as SEARCH_ACTIONS } from 'widget/redux/client/actions/search';

const DEFAULT_STATE = {
  searchQuery: '',
  searchQueryField: SEARCH_QUERY_FIELDS.QUERY,
};

const updateSearch = (state, { payload }) => {
  const { searchQuery, searchQueryField } = payload;
  return {
    ...state,
    searchQuery,
    searchQueryField,
  };
};

export default handleActions({
  [SEARCH_ACTIONS.UPDATE_SEARCH]: updateSearch,
  [SEARCH_ACTIONS.RESET_SEARCH]: () => DEFAULT_STATE,
}, DEFAULT_STATE);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/search.js